import React from 'react';
import { getConfiguration } from '../../utils/configuration';
import { getCurrencyValue } from '../../utils/getCurrencyValue';
import { getFormattedTimestamp } from '../../utils/getFormattedTimestamp';
import ShopReceiptHeader from './common-includes/ShopReceiptHeader';
import ShopReceiptFooter from './common-includes/ShopReceiptFooter';
import { getLabel } from '../../../data/labels';

function ReserveDepositForFinalUserReceipt(props) {
	const additionalStyle = {
			"fontFamily" : "sans-serif",
			"fontSize" : "19px"
	}
	const conf = getConfiguration();
	const data = props.data;
	const xshopFolder = window.location.pathname.split('/xshop')[0]; // /xportapp/xshop -> /xsportapp or ''
	let rootPath = window.location.origin + (xshopFolder.length > 0? xshopFolder : '/');
	rootPath = rootPath + "/xshop-booker/big-winning";
	let instructions = getLabel('retail.reserved_deposit.instructions');
	instructions = instructions.replaceAll('{{SITE}}', rootPath);
	return (
		<body style={additionalStyle}>
			<ShopReceiptHeader customerLogo={props.customerLogo} aamsLogo={props.aamsLogo} operationTitle={getLabel('retail.reserved_deposit.title')}></ShopReceiptHeader>
			
			<div>{getLabel('retail.date_time')}: <span className="bold"> {getFormattedTimestamp()} </span></div>
			<div>{getLabel('general.ticket')}: <span className="bold"> {data.ticketId} </span></div>
			<div>{getLabel('retail.amount')}: <span className="bold"> {getCurrencyValue(data.amount, conf.cs.m , conf.cs.nd, conf.cs.ct)} </span></div>
			<div>{getLabel('retail.document_id')}: <span className="bold"> {data.documentId} </span></div>
			<hr className="hr-line" />
			<div>{instructions}</div>
			<ShopReceiptFooter></ShopReceiptFooter>
		</body>
    );
}

export default ReserveDepositForFinalUserReceipt;